import React from "react";

const Card = ({ title, content, buttonLabel }) => (
  <div className="bg-white p-4 md:p-6 rounded-lg shadow-lg">
    <h2 className="text-lg md:text-xl font-semibold text-gray-800">{title}</h2>
    <div className="mt-4">{content}</div>
    {buttonLabel && (
      <button className="bg-red-600 text-white mt-4 px-4 py-2 rounded hover:bg-red-700 text-sm md:text-base">
        {buttonLabel}
      </button>
    )}
  </div>
);

export default Card;
